import { BaseApi } from '@/api/BaseApi'
import Config from '@/const/Config'
import { CreateRoleReq, PermissionOptions, Permission, SaveRoleReq } from '@/types/Permissions'

export class PermissionRolesApi extends BaseApi {
  public async getAllOptions(): Promise<PermissionOptions> {
    try {
      const res = await this.get<PermissionOptions>(Config.API_URL + '/permission/options/all')
      return res.data
    } catch (e: unknown) {
      console.error('e', e)
      throw e
    }
  }

  public async create(req: CreateRoleReq): Promise<boolean> {
    try {
      const res = await this.post<boolean>(Config.API_URL + '/permission/create_role', req)
      return res.data
    } catch (e: unknown) {
      console.error('e', e)
      throw e
    }
  }

  public async save(req: SaveRoleReq): Promise<boolean> {
    try {
      const res = await this.post<boolean>(Config.API_URL + '/permission/save_role', req)
      return res.data
    } catch (e: unknown) {
      console.error('e', e)
      throw e
    }
  }

  public async setInitRole(roleId: number): Promise<boolean> {
    try {
      const res = await this.post<boolean>(Config.API_URL + '/permission/set_init_role', { roleId })
      return res.data
    } catch (e: unknown) {
      console.error('e', e)
      throw e
    }
  }

  public async getPermissionsByRoleId(roleId: number): Promise<Permission[]> {
    try {
      const res = await this.post<Permission[]>(Config.API_URL + '/permission/get_perms_by_role_id', { roleId })
      return res.data
    } catch (e: unknown) {
      console.error('e', e)
      throw e
    }
  }
}